import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './DJCPSearch.css';

function DJCPSearch({ tableData }) {
    return (
        <div className="DJCP_search-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No se encontraron resultados para DJCP</h4>
            )}
        </div>
    );
}

export default DJCPSearch;
